const table = [
    {
        prop: 'demand.code',
        label: 'Proyecto',
    },      
    {
        prop: 'name',
        label: 'Nombre'
    },
    {
        prop: 'description',
        label: 'Descripción'
    },
    {
        prop: 'date',
        label: 'Fecha'
    },
    {
        prop: 'month',
        label: 'Mes'
    },  
]

export default table
